import { inject, Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { ActivityState, ActivityStore } from './activity.store';

@Injectable({ providedIn: 'root' })
export class ActivityQuery extends QueryEntity<ActivityState> {
  protected store: ActivityStore;

  constructor() {
    const store = inject(ActivityStore);

    super(store);

    this.store = store;
  }
}
